<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-row no-gutters justify="space-between">
				<v-col cols="12" md="3" order-md="1" order="2" class="mt-4 mt-sm-0">
					<h6 class="font-weight-bold text-h6">
						<template v-if="thisMonth == month && thisYear == year"
							>当月棚卸し：{{ inventoryStatus }}</template
						>
						<template v-else> 表示月：{{ year }}年{{ month }}月 </template>
					</h6>
				</v-col>
				<v-col cols="12" md="9" order-md="2" order="1">
					<v-row no-gutters justify="end">
						<ConstructionInventorySelectDialog
							:year="year"
							:month="month"
							@fetch-inventory="fetchOldInventory($event.year, $event.month)"
						/>
						<ConfirmationDialog
							:accept_text="'現在の数値で棚卸'"
							:confirm_options="{ title: '棚卸し確認', cancel_text: 'キャンセル' }"
							:dialog.sync="confirmationDialog"
							requireBtn
							@accept="createInventory"
						>
							<template v-slot:text>
								<p>現在の内容で棚卸しデータを作成しますか？</p>
								<p>
									対象月:
									<span v-text="`${year}年${month}月`"></span>
								</p>
							</template>
							<template v-slot:accept-text>
								<v-icon class="mr-1">mdi-check</v-icon>
								作成する
							</template>
						</ConfirmationDialog>
						<ConstructionStockNewDialog />
					</v-row>
				</v-col>
			</v-row>
			<div>
				<h6 class="font-weight-bold text-body-1 mt-4">ゴム材料</h6>
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:items="rubbers"
						:headers="headers.rubberHeaders"
						:mobile-breakpoint="240"
						hide-default-header
						:header-props="{
							class: 'hidden',
						}"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:header>
							<thead class="v-data-table-header">
								<tr>
									<th
										role="columnheader"
										scope="col"
										class="text-start"
										:style="`table-layout: fixed; width: ${head.width}px; min-width: ${head.width}px;`"
										v-for="(head, i) in topHeaders()"
										:key="`top-${i}`"
										:colspan="head.colspan"
										:rowspan="head.colspan == 1 ? 2 : 1"
									>
										{{ head.group ? head.group : head.text }}
									</th>
								</tr>
								<tr>
									<th
										role="columnheader"
										scope="col"
										class="text-start"
										:style="`table-layout: fixed; width: ${head.width}; min-width: ${head.width};`"
										v-for="(head, i) in bottomHeaders()"
										:key="`bottom-${i}`"
									>
										{{ head.text }}
									</th>
								</tr>
							</thead>
						</template>
						<template v-slot:item="{ item }">
							<!-- TODO: hoverした時の挙動が変なので要修正 -->
							<tr
								v-for="i of partiallyUsedQuantity(item)"
								:key="`${item.id}-${i}`"
								@click="openDialog(item, 'rubber')"
							>
								<template v-if="i == 1">
									<!-- TODO: 決定したDBのカラム名に合わせること -->
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.name }}</td>
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.lot_number }}</td>
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.thickness }}</td>
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.width }}</td>
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.length }}</td>
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.new_quantity }}</td>
									<!-- TODO: item.使いさしモデル[i-1] -->
									<td>{{ item.partially_used_items[i - 1].length }}</td>
									<td>{{ item.partially_used_items[i - 1].quantity }}</td>
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.stock_length }}</td>
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.reserved_amount }}</td>
									<td :rowspan="partiallyUsedQuantity(item)">{{ item.available_amount }}</td>
								</template>
								<template v-else>
									<!-- TODO: item.使いさしモデル[i-1] -->
									<td>{{ item.partially_used_items[i - 1].length }}</td>
									<td>{{ item.partially_used_items[i - 1].quantity }}</td>
								</template>
							</tr>
						</template>
					</v-data-table>
				</div>
			</div>
			<div>
				<h6 class="font-weight-bold text-body-1 mt-4">その他(KG単位)</h6>
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:items="items_kg"
						:headers="headers.itemKgHeaders"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr @click="openDialog(item, 'item_kg')">
								<td>{{ item.name }}</td>
								<td>{{ item.lot_number }}</td>
								<td>{{ item.amount_per_unit }}</td>
								<td>{{ item.new_unit }}</td>
								<td>{{ item.partially_used }}</td>
								<td>{{ item.stock }}</td>
								<td>{{ item.reserved_amount }}</td>
								<td>{{ item.available_amount }}</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</div>
			<div>
				<h6 class="font-weight-bold text-body-1 mt-4">その他(数量単位)</h6>
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:items="items_quantity"
						:headers="headers.itemQuantityHeaders"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr @click="openDialog(item, 'item_quantity')">
								<td>{{ item.name }}</td>
								<td>{{ item.lot_number }}</td>
								<td>{{ item.stock }}</td>
								<td>{{ item.reserved_amount }}</td>
								<td>{{ item.available_amount }}</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</div>
			<ConstructionStockShowDialog
				:dialog.sync="dialog"
				:type="selectedType"
				:item="selectedItem"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import ConfirmationDialog from "../shared/ConfirmationDialog.vue"
import ConstructionInventorySelectDialog from "./stock_components/ConstructionInventorySelectDialog.vue"
import ConstructionStockNewDialog from "./stock_components/ConstructionStockNewDialog.vue"
import ConstructionStockShowDialog from "./stock_components/ConstructionStockShowDialog.vue"

export default {
	components: {
		CommonFlame,
		ConfirmationDialog,
		ConstructionInventorySelectDialog,
		ConstructionStockNewDialog,
		ConstructionStockShowDialog,
	},
	data() {
		return {
			title: "工事部在庫一覧",
			inventory: null,
			rubbers: [],
			items_kg: [],
			items_quantity: [],
			selectedType: "",
			selectedItem: {},
			headers: headers(),
			authority_flag: false,
			thisYear: Number(moment().format("YYYY")),
			thisMonth: Number(moment().format("MM")),
			month: null,
			year: null,
			confirmationDialog: false,
			dialog: false,
			common,
		}
	},

	mounted() {
		const year = Number(this.$route.query.year) || this.thisYear
		const month = Number(this.$route.query.month) || this.thisMonth
		// this.fetchInventory(year, month, true)
					this.year = year
			this.month = month
		this.rubbers = [...Array(3)].map((_, i) => ({
			id: i,
			name: "XX",
			lot_number: "XX",
			thickness: "XX",
			width: "XX",
			length: "XX",
			new_quantity: "XX",
			stock_length: "XX",
			reserved_amount: "XX",
			available_amount: "XX",
			partially_used_items: [...Array(2)].map((_, n) => ({ length: "XX", quantity: "XX", id: n })),
		}))
		this.items_kg = [...Array(3)].map((_, i) => ({
			id: i,
			name: "XX",
			lot_number: "XX",
			amount_per_unit: "XX",
			new_unit: "XX",
			partially_used: "XX",
			stock: "XX",
			reserved_amount: "XX",
			available_amount: "XX",
		}))

		this.items_quantity = [...Array(3)].map((_, i) => ({
			id: i,
			name: "XX",
			lot_number: "XX",
			stock: "XX",
			reserved_amount: "XX",
			available_amount: "XX",
		}))
	},
	methods: {
		fetchInventory(year, month, first_visit = false) {
			this.year = year
			this.month = month
			const headers = authenticate.setHeader()
			const params = { year, month, first_visit }
			axios
				.get("/erp/v1/constructions/stocks", {
					params,
					headers,
				})
				.then((response) => {
					this.inventory = response.data.inventory
					this.rubbers = response.data.rubbers
					this.items_kg = response.data.items_kg
					this.items_quantity = response.data.items_quantity
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.authority_flag = response.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		createInventory() {
			// TODO:
		},
		openDialog(item, type) {
			this.selectedItem = item
			this.selectedType = type
			this.dialog = true
		},
		partiallyUsedQuantity(item) {
			// TODO: 使いさしの個数を返す メソッドにしなくてもOKかも
			return item.partially_used_items.length ? item.partially_used_items.length : 1
		},
		fetchOldInventory(year, month) {
			this.fetchInventory(year, month, false)
			this.$router.push({
				name: this.$route.name,
				query: { year, month },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		topHeaders() {
			return this.headers.rubberHeaders.reduce((groups, current) => {
				let width = Number(current.width.replace("px", ""))
				const group = groups.find((group) => current.group != null && group.group === current.group)
				if (group) {
					group.colspan += 1
					group.width += width
				} else {
					groups.push({
						group: current.group,
						text: current.text,
						colspan: 1,
						width,
					})
				}
				return groups
			}, [])
		},
		bottomHeaders() {
			return this.headers.rubberHeaders.filter((header) => !!header.group)
		},
	},
	computed: {
		inventoryStatus() {
			// TODO: 要確認
			return this.inventory?.status == "completed" ? "作成済み" : "未作成"
		},
	},
}

function headers() {
	return {
		rubberHeaders: [
			{ text: "材料名", value: "name", width: "100px" },
			{ text: "ロット", value: "lot_number", width: "100px" },
			{ text: "厚み(mm)", value: "thickness", width: "100px" },
			{ text: "幅(mm)", value: "width", width: "100px" },
			{ text: "長さ(新品)(m)", value: "length", width: "100px" },
			{ text: "新品本数", value: "new_quantity", width: "100px" },
			{ group: "使いさし", text: "長さ(m)", value: "partially_used_length", width: "100px" },
			{ group: "使いさし", text: "本数", value: "partially_used_quantity", width: "100px" },
			{ text: "在庫数(m)", value: "stock_length", width: "100px" },
			{ text: "引当済数(m)", value: "reserved_amount", width: "100px" },
			{ text: "引当可能数(m)", value: "available_amount", width: "100px" },
		],
		itemKgHeaders: [
			{ text: "材料名", value: "name", width: "100px" },
			{ text: "ロット", value: "lot_number", width: "100px" },
			{ text: "入り目(kg)", value: "amount_per_unit", width: "100px" },
			{ text: "新品缶数", value: "new_unit", width: "100px" },
			{ text: "使いさし(kg)", value: "partially_used", width: "100px" },
			{ text: "在庫数(kg)", value: "stock", width: "100px" },
			{ text: "引当済数(kg)", value: "reserved_amount", width: "100px" },
			{ text: "引当可能数(kg)", value: "available_amount", width: "100px" },
		],
		itemQuantityHeaders: [
			{ text: "材料名", value: "name", width: "100px" },
			{ text: "ロット", value: "lot_number", width: "100px" },
			{ text: "在庫数(kg)", value: "stock", width: "100px" },
			{ text: "引当済数", value: "reserved_amount", width: "100px" },
			{ text: "引当可能数", value: "available_amount", width: "100px" },
		],
	}
}
</script>
